import z from "zod";

import { ErrorClassification } from "../../../sentry/classification";
import type { ErrorDetails } from "../domain";

const sunrunApiErrorTypeValues = ["SUBTYPE_NOT_FOUND"] as const;
const sunrunApiErrorTypeSchema = z.enum(sunrunApiErrorTypeValues);
const SunrunApiErrorType = sunrunApiErrorTypeSchema.enum;
type SunrunApiErrorType = z.infer<typeof sunrunApiErrorTypeSchema>;

export type SunrunApiErrors = {
  errorType: typeof SunrunApiErrorType.SUBTYPE_NOT_FOUND;
  data: { bidRequestId: string };
};

export const sunrunApiErrorDetails: Record<SunrunApiErrorType, ErrorDetails> = {
  SUBTYPE_NOT_FOUND: {
    classification: ErrorClassification.VALIDATION_ERROR,
    sentryDescription: "Subtype not found for bidRequest",
  },
};
